import { TNavigationTreeNode } from '../../types';

export type TCustomPageHeader = { title: string | null };

export type TNavigationState = {
  selectedNavigationItem: TNavigationTreeNode | null;
  customPageHeader: TCustomPageHeader;
};

export const NavigationInfoActionType = {
  SelectNavigationItem: 'SELECT_NAVIGATION_ITEM' as const,
  SetCustomPageHeader: 'SET_CUSTOM_PAGE_HEADER' as const,
};
